module.exports = __webpack_public_path__ + "static/media/GH1Q.3123dc81.jpg";